import script from "./AdminTenants.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminTenants.vue?vue&type=script&setup=true&lang=js"

import "./AdminTenants.vue?vue&type=style&index=0&id=48a4f3b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48a4f3b8"]])

export default __exports__